import sliceCreator from '../../index.jsx';
import { GET_FARMER_COMMITMENT_BY_ID} from '../../../constants/index.jsx';
const _getFarmerCommitmentByIdAction = sliceCreator('GET_FARMER_COMMITMENT_BY_ID', GET_FARMER_COMMITMENT_BY_ID, 'get');

const { asyncAction: getFarmerCommitmentByIdAction, reducer, clearData: clearGetFarmerCommitmentByIdAction } = _getFarmerCommitmentByIdAction;

export default reducer;

export {
    getFarmerCommitmentByIdAction,
    clearGetFarmerCommitmentByIdAction
}